import { render } from "./CaiGouFuKuan.vue?vue&type=template&id=e452ced0"
import script from "./CaiGouFuKuan.vue?vue&type=script&lang=js"
export * from "./CaiGouFuKuan.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__